import { c as _c } from "react/compiler-runtime";
import { Flex, Stack } from '@chakra-ui/react';
import InteriorHero from '@src/components/sco/LayoutBlocks/InteriorHero';
import SectionWrapper from '@src/components/sco/LayoutBlocks/SectionWrapper';
import { MarkdownRenderer } from '@src/components/sco/MarkdownRenderer';
import { SEOMetadata } from '@src/components/sco/utilities/SEOMetadata';
import { useActiveContentContext } from '@src/contexts/ActiveContentContext';
import termsOfServiceContent from '@src/data/terms-of-service.md';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect.tsx';
import { PageWithNavBar } from '@src/templates/PageWithNavBar.tsx';
export { getServerSideProps } from '@src/lib/server-side-rendering.tsx';
export default function Page() {
  const $ = _c(4);
  const activeContent = useActiveContentContext();
  let t0;
  if ($[0] !== activeContent) {
    t0 = () => {
      activeContent.setSiteSection?.("legal.tos");
    };
    $[0] = activeContent;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useUniversalEffect(t0);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <InteriorHero centerContent={true} description="Rules of the road." title="Terms of Service" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <PageWithNavBar><Flex align="center" justify="center" width="full"><Stack align="center" direction="column" gap={0} width="full"><SectionWrapper maxWidth="container.md">{t1}<MarkdownRenderer preset="article">{termsOfServiceContent.toString()}</MarkdownRenderer></SectionWrapper></Stack></Flex><SEOMetadata description="Rules of the road." title="Terms of Service" /></PageWithNavBar>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}